<template>
    <div id="app" v-if="hasAccess && hasPreregisterd">
        <router-view />
        <Footer />
        <Alert />
    </div>
    <div v-else-if="!hasPreregisterd && this.account !== undefined">
      <div class="no-access-container">
        <div class="no-access-logo">
          PASS on Point
          <div class="no-access-description">
            {{ displayText }}
            <InputDropdownFilter class="dropdownFilter" v-if="dropdownLocations != undefined && link_location == undefined" v-model="location.name" placeholder="Select location" ref="locations" :data="dropdownLocations" v-on:change="updateLocation"/>
            <InputText class="dropdownFilter" v-if="location.id != undefined || given_location != undefined" v-model="registrationMessage" placeholder="message" ref="message"/>
            <InputButton class="btn" title="Apply" v-on:button-pressed="apply()" v-if="location.id != undefined || given_location != undefined"/>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="hasPreregisterd">
        <div class="no-access-container">
            <div class="no-access-logo">
                PASS on Point
                <Loader loading/>
                <div class="no-access-description">
                    Your account has not yet been activated, please ask your administrator to provide you access to the system.
                    <br /><br />
                    If you want to use another account, click <a href="javascript:" v-on:click="logout()">here</a>.
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="this.account === undefined">
      <div class="no-access-container">
        <div class="no-access-logo">
          PASS on Point
          <Loader loading/>
          <div class="no-access-description">
            Your account is currently being setup, please try again in a couple of minutes.
            <br /><br />
            logout <a href="javascript:" v-on:click="logout()">here</a>.
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Footer from './components/footer/Footer'
import Alert from './components/alert/Alert'
import Loader from './components/loader/Loader'
import { KeycloakService } from './services/keycloak.service'
import InputDropdownFilter from './components/input-dropdown-filter/InputDropdownFilter'
import InputButton from "./components/input-button/InputButton.vue";
import InputText from "./components/input-text/InputText.vue";

export default {
  components: {
      Footer,
      Alert,
      Loader,
      InputDropdownFilter,
      InputButton,
      InputText
  },

  props: {
    given_location: undefined
  },

  data() {
    return {
      dropdownLocations: undefined,
      locations: [],
      location: {name: "No location selected"},
      account: undefined,
      registrationMessage: undefined
    }
  },

  async mounted() {
    const service = require('./services/location.service')
    this.locations = await service.LocationService.getLocations()
    this.dropdownLocations = this.locations.map((location) => {
      return {id: location.id, value: location.name}
    })
    const userId = KeycloakService.getUser()
    const accountService = require("./services/account.service")
    await accountService.AccountService.getAccount(userId)
        .then((account) => {
          this.account = account
        })
        .catch((err) => {
          console.error(err)
        })
  },


  computed: {
        hasAccess() {
            return KeycloakService.hasAccess()
        },

        hasPreregisterd() {
           return KeycloakService.isPreregistered()
        },

        link_location () {
          return this.locations.find(l=> l.id === this.given_location)
        },

        displayText () {
          if (this.given_location !== undefined && this.link_location) {
            return `Registering for ${this.link_location.name}:`
          } else {
            return 'Please specify for which location you are registering:'
          }
        }
    },

    methods: {
        logout() {
            KeycloakService.logout()
        },

        updateLocation(id) {
          this.location = this.locations.filter(location => location.id == id)[0]
        },

        async apply () {
          let locationId = undefined
          if (this.link_location) {
            locationId = this.link_location.id.toString()
          } else {
            locationId = this.location.id.toString()
          }

          this.account.attributes = {locationId: locationId}
          if (this.registrationMessage !== undefined) this.account.attributes["message"] = this.registrationMessage

          const accountService = require("./services/account.service")
          let payload = this.account
          payload['isApplication'] = true
          accountService.AccountService.updateAccount(payload).then((success) => {
              window.location.reload()
            }).catch((error) => {
              console.error(error)
              alert("Something went wrong, please try again later.")
            })
        }
    }
}
</script>

<style>
@import "https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined";
@import "https://fonts.googleapis.com/css?family=Source+Sans+Pro:200,200i,300,300i,400,400i,600,600i,700,700i,900,900i&display=swap";
@import "https://fonts.googleapis.com/css?family=Montserrat:200,200i,300,300i,400,400i,600,600i,700,700i,900,900i&display=swap";

BODY, HTML {
    background-color: #F9F9F9;
    margin: 0px;
    padding: 0px;
}

#app {
    background-color: #FFF;
    font-family: "Source Sans Pro", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.no-access-container {
    background-color: #FFF;
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    text-align: center;
}

.no-access-logo {
    box-sizing: border-box;
    color: #27ABDC;
    font-family: "Montserrat", sans-serif;
    font-size: 21px;
    font-style: italic;
    font-weight: 700;
    margin: 0;
    padding: 32px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
}

.no-access-description {
    color: #000;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
}

.no-access-description > A {
    color: #000;
    font-weight: bold;
}

.tooltip {
    background-color: #00000080;
    border-radius: 3px;
    color: #FFF;
    font-family: "Source Sans Pro", sans-serif;
    font-size: 12px;
    padding: 5px 10px;
    z-index: 15;
}

.tooltip-navigation-bar {
    top: 8px !important;
}

.tooltip-booking {
    top: 80px !important;
}

.dropdownFilter {
  width: 20%;
  padding-top: 2%;
  margin-left: 40%;
}

.btn {
  margin-top: 1%;
}
</style>
